var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" "),_c('a',{staticClass:"text-primary",attrs:{"href":"https://exportai.me","target":"_blank"}},[_vm._v("Export.ai")]),_vm._v(" "),_c('i',{staticClass:"fas fa-building"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }